import axios, { capi, extractData } from '@atheneum/api'
import { extendObservable } from 'mobx'
import { v4 as generateUUID } from 'uuid'

class CorrespondenceStore {
  constructor(staticData) {
    extendObservable(this, {
      emails: [],
      staticData,
      loading: false,
      loadingUUID: null,
      partialLoad: false,
      isFullyLoaded: false,
      loadingMessage: '',
      loadingDetails: false
    })
  }

  loadPartialData(projectId, offset = 0) {
    this.partialLoad = true
    this.loadingMessage = ''
    if (this.emails.length === 0) this.loading = true
    const LIMIT = 100
    return capi.loadCorrespondence({ projectId, offset, limit: LIMIT }).then(res => {
      const data = extractData(res)
      if (offset) {
        this.emails = this.emails.concat(data)
      } else {
        this.emails.replace(data)
      }
      this.loading = false
      this.partialLoad = false
      if (data.length) {
        this.isFullyLoaded = false
        this.loadingMessage = ''
        return data
      } else {
        this.loadingMessage = 'End of the list.'
        this.isFullyLoaded = true
      }
    })
      .catch(e => {
        this.partialLoad = false
        this.loading = false
        console.error(e)
      })
  }

  getAll(projectId, offset = 0, loadingUUID) {
    if (!loadingUUID) {
      loadingUUID = generateUUID()
      this.loadingUUID = loadingUUID
    }
    if (this.loadingUUID !== loadingUUID) return
    this.loading = true

    const LIMIT = 100

    return capi.loadCorrespondence({ projectId, offset, limit: LIMIT })
      .then(res => {
        if (this.loadingUUID !== loadingUUID) return
        const data = extractData(res)
        if (offset) {
          this.emails = this.emails.concat(data)
        } else {
          this.emails.replace(data)
        }
        if (data.length) return this.getAll(projectId, offset + LIMIT, loadingUUID)
        else this.loading = false
      })
      .catch(e => {
        this.loading = false
        console.error(e)
      })
  }
  getCorrespondenceDetails = async (id, type) => {
    try {
      this.loadingDetails = true
      const result = await capi.getCorrespondenceById(id, type)
      this.loadingDetails = false
      return result
    } catch (error) {
      console.error(error)
    }
  }
  upload = async data => {
    try {
      const uploadPath = await capi.upload(data)
      return {
        link: uploadPath.link,
        id: uploadPath.id,
        path: `attachments/${data.filename}`
      }
    } catch (error) {
      console.error(error)
    }
  }

  deleteFile = async id => {
    try {
      await capi.deleteFile(id)
    } catch (error) {
      console.error(error)
    }
  }

  sendFile = async (file, link) => {
    this.loading = true

    try {
      await axios.put(link, file, {
        headers: {
          'Content-Type': file.contentType
        }
      })
      this.loading = false
    } catch (error) {
      this.loading = false
      console.error(error)
    }
  }

  reply(emailId, subject, body, attachments, isCorrespondence) {
    this.loading = true
    return capi.reply({
      emailId,
      subject,
      body,
      attachments,
      isCorrespondence
    })
      .catch(e => {
        console.error(e)
      }).finally(res => {
        this.loading = false
      })
  }
}

export default CorrespondenceStore
